import axios from 'axios'
import router from './router'
import config from './config'
import store from './store/store'

const axiosInstance = axios.create({
  baseURL: config.baseUrl,
  withCredentials: true
})
const TIME_CHECK = 3480000
function checkStillActive () {
  let lastRequest = store.state.workingStatusLastRequest
  let now = new Date()
  let timeCheck = TIME_CHECK // 58 minutes
  if (new Date(lastRequest) instanceof Date) {
    let timeLeft = now.getTime() - new Date(lastRequest).getTime()
    if (timeLeft >= timeCheck) {
      store.commit('setOpenModalLogin', true)
    } else {
      if (store.state.workingStatusTimeOut) {
        clearTimeout(store.state.workingStatusTimeOut)
      }
      let timeOut = setTimeout(checkStillActive, timeCheck - timeLeft)
      store.commit('setWorkingTimeOut', timeOut)
    }
  }
}

axiosInstance.interceptors.response.use(function (response) {
  let urlApi = response.config.url
  if (urlApi) {
    urlApi = urlApi.replace(config.baseUrl, '')
  }
  let declineUrls = [
    '/encounter/patient', '/encounter/file',
    '/encounter/latest-medication-patient', '/encounter/chat', '/encounter/addendum',
    '/encounter/item/verify-concurrent-edit',
    '/dashboard/get-newest-injection',
    '/message-skin-test/get-data',
    '/adjustment/get-data',
    '/message-skin-test/get-data',
    '/request-off',
    '/patients/addendum',
    '/patients/verify-concurrent-edit',
    '/bill/ledger/verify-concurrent-edit'
  ]
  if (declineUrls.indexOf(urlApi) < 0) {
    if (store.state.workingStatusTimeOut) {
      clearTimeout(store.state.workingStatusTimeOut)
    }
    let timeOut = setTimeout(checkStillActive, TIME_CHECK)
    store.commit('setWorkingStatus', timeOut)
  }
  // if (response.data.s === 401) { 540000
  //   let type = response.data.type
  //   router.replace({name: 'login', query: {type: type}})
  // }
  return response
}, function (error) {
  let status = error.response.status
  switch (status) {
    case 403:
      let permissions = error.response.data.permissions
      store.commit('setUserPermissions', permissions)
      router.replace({ name: 'pageNotFound' })
      break
    case 401:
      let type = error.response.data.type
      window.location.href = '/login?type=' + type
      // router.replace({ name: 'login', query: { type: type } })
      break
    default:
      console.log(error)
  }
  return Promise.reject(error)
})
export default axiosInstance
